const status = {
    state : {
      login:false,  // 登录弹框的状态
      Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : '',  // 请求数据
      loginStatus:true,   // 登录和注册的切换
      submitStatus:false, // 提问提交
      screenshotStatus:false, // 截屏
      /* 编辑截屏 */
      edit_status:false,
      web_info:'',
      submitRecodeStatus:'', // 提交视频观看记录
      category:0, // 素材分类id
      blank_text:'',// 空白页面提示文字
      message_count:null,
      isAgreement:false,//是否阅读协议
    },
    mutations: {
        changeLogin (state, user) {
          state.Authorization = user.Authorization
          let type = localStorage.getItem('type')
          if (type === 'firm') {
            localStorage.setItem("access_token",user.Authorization)
          } else {
            localStorage.setItem("Authorization",user.Authorization)
          }
        },
        webInfo(state,info) {
          state.web_info = info
        }
    }
}
export default status



// WEBPACK FOOTER //
// ./src/store/status.js